<div [hidden]="authority.transferSuccess || Status.AUTHORITY_HIDDEN === authority.status" class="table-row-wrapper action-group-visible 
{{
    this.authority.sourceSystemName === Source.TRANSFER_TO_PAPER && !isTTPSuccessFul && !authority.transferFailed
      ? 'atm'
      : (authority.sourceSystemName | lowercase)
  }}" [ngClass]="{
    'under-action': operatedUpon && isActionAllowed(),
    updated: updated,
    'action-based': Status.AUTHORITY_APPROVED === authority.status || Status.RELEASE_APPROVED === authority.status,
    'transfer-failed': authority.transferFailed,
    'shape-padding':
      [
        Status.CHANGE_REQUEST,
        Status.CHANGE_SENT,
        Status.CHANGE_PENDING,
        Status.CHANGE_USER_REJECTED,
        Status.CHANGE_USER_APPROVED,
        Status.CHANGE_DISPATCHER_APPROVED
      ].indexOf(authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus) >= 0,
      'authority-card':isAuthorityCard
  }">
  <div class="table-column-status-wrapper column-status {{
      isSecondaryRequestPending ? 'request_submitted' : (authority.displayStatus | lowercase)
    }} " [ngClass]="{ 'released-secondary':  !authority.isLoggedUserPrimary && [
    eicStatus.RELEASED,
    eicStatus.REJECTED,
    eicStatus.CANCELLED].indexOf(authority.loggedInEICDetail?.status) >= 0 }"
    *ngIf="!isAuthorityHistory && !isAuthorityCard">
    <i class="csx-arrows_spot_1"></i>
    <i class="csx-common_in_progress"></i>
    <i class="csx-common_approve"></i>
    <i class="csx-common_alert"></i>
    <i class="csx-common_check" *ngIf="!isSecondaryRequestPending &&  [
    eicStatus.RELEASED,
    eicStatus.REJECTED,
    eicStatus.CANCELLED].indexOf(authority.loggedInEICDetail?.status) < 0"></i>
    <i class="csx-arrows_deallocate"></i>
    <i class="csx-common_ban"></i>
    <i class="csx-common_delete"></i>
    <span></span>
  </div>

  <div class="authority-row authority-card-header" *ngIf="isAuthorityCard">
    <div class="table-header-authoritycard">
      <div class="table-column column-line">Line</div>
      <div class="table-column column-from">Operating From</div>
      <div class="table-column column-to">Operating To</div>
      <div class="table-column column-direction">Direction</div>
    </div>
  </div>

  <div [ngClass]="{
      divider: authority.lineItems.length - 1 !== i,
      'change-history-mobile-view': isAuthorityHistory,
      'pad-left-0': isAuthorityHistory,
      'with-action-btn': isMobileViewPendingStatus
    }" class="authority-row {{ authority.displayStatus | lowercase }} pad-left-40"
    *ngFor="let lineItem of authority.lineItems; let i = index" [hidden]="lineItem.cancelled !== undefined">
    <div class="table-column column-ec1number" [ngClass]="{ empty: firstActiveLineItemIndex !== i }"
      *ngIf="showActionButtons && !isAuthorityHistory">
      <span *ngIf="firstActiveLineItemIndex === i">{{ showEC1Number() ? '#' + authority.ec1Number : '-' }}</span>
    </div>
    <div class="table-column" [ngClass]="{
        'column-line': !isAuthorityHistory,
        'column-line-au': isAuthorityHistory
      }">
      <span>{{ lineItem.lineNumber }}</span>
    </div>

    <div *ngIf="!isAuthorityCard" class="table-column" [ngClass]="{
        'column-operate-on': !isAuthorityHistory,
        'column-operate-on-au': isAuthorityHistory
      }">
      <div class="from-text">
        <span>{{ lineItem.operateOn === undefined || lineItem.operateOn === null ? '-' : lineItem.operateOn }}</span>
      </div>
    </div>
    <div class="operating-columns">
      <i class="csx-arrows_switch_vertical_2"></i>

      <div class="table-column" [ngClass]="{
          'column-from': !isAuthorityHistory,
          'column-from-au': isAuthorityHistory
        }">
        <div class="from-text">
          <span>
            <span class="from-label">{{ lineItem.fromPoint !== undefined ? lineItem.fromPoint.displayName : '' }}</span>
            {{ lineItem.fromPoint !== undefined ? getTrackName(lineItem.fromPoint.location) : '' }}
          </span>
        </div>
      </div>
      <div class="table-column" [ngClass]="{
          'column-to': !isAuthorityHistory,
          'column-to-au': isAuthorityHistory
        }">
        <div class="from-text">
          <span><span class="from-label">{{ lineItem.toPoint !== undefined ? lineItem.toPoint.displayName : '' }}</span>
            {{ lineItem.toPoint !== undefined ? getTrackName(lineItem.toPoint.location) : '' }}</span>
        </div>
      </div>
    </div>

    <div class="table-column" [ngClass]="{
        'column-direction': !isAuthorityHistory,
        'column-direction-au': isAuthorityHistory
      }">
      <span [ngClass]="{ highlighted: hasLineItemDirectionChanged(lineItem.id) }">{{ Direction[lineItem.direction]
        }}</span>
    </div>
    <div *ngIf="!isAuthorityCard" class="table-column" [ngClass]="{
        'column-dated': !isAuthorityHistory,
        'column-dated-au': isAuthorityHistory
      }">
      <div class="to-time">
        Until:&nbsp;
        <span [ngClass]="{ highlighted: hasExpirationDateChanged() }">{{ authority.expiration | estDate | date:
          'MM/dd/yyyy HH:mm' }}</span>
      </div>
      <div class="from-time">
        Effective:&nbsp;
        <span [ngClass]="{ highlighted: hasEffectiveDateChanged() }">{{
          authority.effective === undefined ? '-' : (authority.effective | estDate | date: 'MM/dd/yyyy HH:mm')
          }}</span>
      </div>
      <div class="dispatcher">
        Dispatcher:&nbsp;
        <span>{{ authority.dispatcher === null || authority.dispatcher === undefined ? '-' : authority.dispatcher }}
        </span>
      </div>
      <div class="dispatcher"
        *ngIf="(authority.isAuthorityShared && authority.primaryDetail 
        && (!authority.isLoggedUserPrimary || isAuthorityHistory)) || (authority.primaryDetail && !authority.isLoggedUserPrimary)">
        RWIC:&nbsp;
        <span>{{ authority.primaryDetail?.eicUserId + '-' + authority.primaryDetail?.eicEmployeeName }} </span>
      </div>
      <div class="released-time" *ngIf="Status.RELEASED === authority.status">
        Released:&nbsp;
        <span class="highlighted">{{
          authority.released === null || authority.released === undefined
          ? '-'
          : (authority.released | estDate | date: 'MM/dd/yyyy
          HH:mm')
          }}
        </span>
      </div>
      <div class="released-time" *ngIf="Status.AUTHORITY_REJECTED === authority.status">
        Denial Code:&nbsp;
        <span class="highlighted">{{ authority.denialReasonCode }}</span>
      </div>
    </div>
    <div class="table-column column-actions" [ngClass]="{ empty: firstActiveLineItemIndex !== i }"
      *ngIf="!isAuthorityHistory && actionTableVisible && !isAuthorityCard">
      <div *ngIf="firstActiveLineItemIndex === i" class="actions-column-wrapper">
        <div class="actions-column-button-group action-based with-danger-button alt-actions"
          *ngIf="Status.AUTHORITY_APPROVED === authority.status">
          <button pButton type="button" (click)="updateOperatedUpon(true)" label="Cancel Authority"
            class="p-button-danger" [disabled]="!systemState.state || isAdmin()"></button>
          <button pButton type="button" (click)="requestAction(Status.AUTHORITY_USER_APPROVED)" label="Review Authority"
            class="p-button-success" [disabled]="!systemState.state || isAdmin()"></button>
        </div>
        <div class="actions-column-button-group action-based with-danger-button alt-actions"
          *ngIf="Status.RELEASE_APPROVED === authority.status && checkPrimaryRelease()">
          <button pButton type="button" (click)="updateOperatedUpon(true)" label="Cancel Release"
            class="p-button-danger" [disabled]="!systemState.state || isAdmin()"></button>
          <button pButton type="button" style="margin-left:1px;" (click)="requestAction(Status.RELEASE_USER_APPROVED)"
            label="Accept Release" class="p-button-success" [disabled]="!systemState.state || isAdmin()"></button>
        </div>
        <div class="actions-column-button-group alt-actions" *ngIf="Status.AUTHORITY_REJECTED === authority.status">
          <button pButton type="button" (click)="copyAndResubmitAuthority()" label="Copy & Resubmit"
            class="p-button-outlined copy-resubmit" [disabled]="!systemState.state || isAdmin()"></button>
        </div>
        <div class="actions-column-button-group active-authority" *ngIf="
            (Status.ACTIVE === authority.status &&
            !authority.transferFailed &&
            (!isReviewSharedButtonEnable || authority.isLoggedUserPrimary) &&
            showActionButtons &&
            !isTTPSuccessFul &&
          !isSecondaryRequestPending) || Status.RELEASED === authority.status
          ">
          <div class="inline-container" (click)="createComment()" [ngClass]="{
              'ui-state-disabled': !systemState.state || isAdmin(),
              'hide-icon': authority.status === Status.RELEASED ||  [
              eicStatus.RELEASED,
              eicStatus.REJECTED,
              eicStatus.CANCELLED].indexOf(authority.loggedInEICDetail?.status) >= 0
            }">
            <div class="icon-wrapper">
              <i class="icon csx-common_comment"></i>
            </div>
            <div class="comment-action-label"
              [class.hide-icon]="authority.sourceSystemName === Source.TRANSFER_TO_PAPER">Comment</div>
          </div>

          <div class="inline-container">
            <div class="comment-action-label">Options</div>
            <div class="icon-wrapper">
              <i class="pi pi-ellipsis-v icon common_options " (click)="menu.toggle($event)"></i>
              <div class="p-menu-fixed">
                <p-menu appendTo="body" #menu [popup]="true" [model]="authority.authorityMenu">
                  <ng-template pTemplate="item" let-item>
                    <a (click)="onClickAuthorityMenu(item.label)" class="p-menuitem-link">
                        <span [class]="item.icon"></span>
                        <span class="ml-2">{{ item.label }}</span>
                    </a>
                  </ng-template>
                </p-menu>
              </div>
            </div>
          </div>

          <div class="buttons-container">
            <button pButton type="button"
              (click)="enableReleaseShareAuthorityButton ? requestAction(Status.SHARING_RELEASE) : requestAction(Status.RELEASE_REQUESTED)"
              label="Release {{ enableReleaseShareAuthorityButton ? 'Shared ' : '' }} Authority"
              class="p-button-outlined release-authority " [disabled]="!systemState.state || isAdmin()" [ngClass]="{
                'hide-icon': hideShareButton ||  [
                eicStatus.RELEASED,
                eicStatus.REJECTED,
                eicStatus.CANCELLED].indexOf(authority.loggedInEICDetail?.status) >= 0,
                'flash-button': authority.eicChangeRequests[authority.loggedInEICDetail.eicUserId]?.authorityChangeRequestStatus === Status.UNSHARING_INITIATED
              }"></button>
            <button pButton type="button" (click)="requestAction(Source.TRANSFER_TO_PAPER)" [disabled]="isAdmin()"
              label="Transfer To Paper" class="p-button-outlined transfer-to-paper" [ngClass]="{
                'shape-ttp': statusArray.indexOf(authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus) >= 0,
                width100:
                  statusArray.indexOf(authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus) >= 0 ||
                  authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus === Status.CHANGE_DISPATCHER_APPROVED,
                  'hide-icon': authority.status === Status.RELEASED ||  [
                  eicStatus.RELEASED,
                  eicStatus.REJECTED,
                  eicStatus.CANCELLED].indexOf(authority.loggedInEICDetail?.status) >= 0,
                  'flash-button' : authority.sourceSystemName === Source.TRANSFER_TO_PAPER
              }"></button>
          </div>

          <div class="actions-column-button-group change-request-authority review-modification">
            <button pButton type="button" (click)="updateOperatedUpon(true)" [ngClass]="{
                'hide-icon':
                  !authority.isLoggedUserPrimary ||
                  authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus !== Status.CHANGE_DISPATCHER_APPROVED || authority.status === Status.RELEASED
              }" [disabled]="!systemState.state || isAdmin()" label="Cancel Modify" class="p-button-danger"></button>
            <button pButton type="button" (click)="requestAction(Status.CHANGE_USER_APPROVED)"
              [disabled]="!systemState.state || isAdmin()" [ngClass]="{
                'hide-icon':
                  !authority.isLoggedUserPrimary ||
                  authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus !== Status.CHANGE_DISPATCHER_APPROVED || authority.status === Status.RELEASED
              }" label="Accept Modify" class="p-button-success"></button>
          </div>
        </div>
        <div class="review-share-action" *ngIf="isReviewSharedButtonEnable">
          <button pButton type="button" class="p-button-outlined release-authority flash-button"
            (click)="reviewSharedAuthority()" [disabled]="!systemState.state || isAdmin()"
            label="Review Shared Authority"></button>
        </div>

        <div class="review-share-action" *ngIf="isReviewButtonEnable">
          <button pButton type="button" class="p-button-outlined release-authority flash-button"
            (click)="reviewAuthority()" [disabled]="!systemState.state || isAdmin()"
            label="Review Shared Request"></button>
        </div>

        <div class="review-share-action" *ngIf="showReviewModificationButton">
          <button pButton type="button" class="p-button-outlined release-authority flash-button"
            (click)="reviewModification()" [disabled]="!systemState.state || isAdmin()"
            label="Review Modification"></button>
        </div>

        <div class="review-share-action"
          *ngIf="authority.isSharedModificationRejected && !authority.modifyReportbyChangeRequest.authorityChangeRequestId">
          <button pButton type="button"
            class="p-button-outlined release-authority review-rejected-modification flash-button-red"
            (click)="onClickReviewRejected()" [disabled]="!systemState.state || isAdmin()"
            label="Review Rejected Modification"></button>
        </div>
        <div class="actions-column-button-group ttp-authority"
          *ngIf="authority.sourceSystemName === Source.TRANSFER_TO_PAPER && authority.transferFailed">
          <button pButton type="button" (click)="requestAction(Source.TRANSFER_TO_PAPER)" [disabled]="isAdmin()"
            label="Transfer To Paper" class="p-button-outlined transfer-to-paper"></button>
        </div>
        <div class="actions-column-text-group" *ngIf="
            this.authority.sourceSystemName !== Source.TRANSFER_TO_PAPER && Status.RELEASED !== this.authority.status &&
            !showReviewModificationButton && checkPrimaryRelease() &&
            (AppConstant.AWAITING_RESPONSE_MODIFICATION_STATUS.indexOf(this.authority.status) >= 0 ||
              statusArray.indexOf(authority.modifyReportbyChangeRequest?.authorityChangeRequestStatus) >= 0 ||
              sharedAwaitingReponse)
          ">
          <span>Awaiting for Response</span>
        </div>
        <div class="actions-column-text-group release-requested-button"
          *ngIf="AppConstant.AWAITING_RESPONSE_RELEASED_AUTHORITY_STATUS.indexOf(this.authority.status) >= 0 && checkPrimaryRelease()">
          <span>Release Requested, <br />Waiting for Approval</span>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'pad-left-0': isAuthorityHistory }"
    class="authority-row change-history-mobile-view additional-line pad-left-40"
    *ngFor="let crossOver of authority.crossOvers; let i = index" [hidden]="crossOver.cancelledDate !== undefined">
    <div class="table-column column-ec1number empty" *ngIf="!isAuthorityHistory && !isAuthorityCard">
      <span></span>
    </div>
    <div class="table-column column-line">
      <span>{{ crossOver.lineNumber }}</span>
    </div>
    <div class="table-column crossover">
      <i class="csx-arrows_switching"></i>
      <span class="highlighted">{{ crossOver.location + ' ' + crossOver.fromTrack.name + ' -> ' + crossOver.toTrack.name
        }}
      </span>
    </div>
  </div>

  <div [hidden]="isAuthorityCard" [ngClass]="{ 'pad-left-0': isAuthorityHistory }"
    class="authority-row change-history-mobile-view additional-line pad-left-40"
    *ngFor="let comment of getLine11Items(); let i = index">
    <div>
      <div class="table-column column-ec1number empty" *ngIf="!isAuthorityHistory && !isAuthorityCard"></div>
      <div class="table-column column-line" [ngClass]="{ empty: i !== 0 }">
        <span *ngIf="i === 0">11</span>
      </div>
      <div class="table-column ">
        <span class="highlighted">{{ comment.text }}</span>
      </div>
    </div>
  </div>
  <div
    *ngIf="authority.modifyReportbyChangeRequest.authorityChangeRequestStatus === Status.CHANGE_USER_APPROVED.toString() && !isAuthorityCard && checkPrimaryRelease()">
    <div class="authority-comment changerequest-message">
      <div class="comment-wrapper" [ngClass]="{ 'change-message': i === 0 }"
        *ngFor="let item of getChangeMessages();let i = index">
        <span style="font-size: 18px;"> {{item.text}}</span>
      </div>
    </div>
    <div class="authority-comment useracceptance-message">
      <div class="comment-wrapper" *ngFor="let item of getTimeExtensionItems();let i = index">
        <span style="font-size: 18px;"> {{item.text}}</span>
      </div>
    </div>
    <div class="authority-comment useracceptance-message">
      <div class="comment-wrapper" *ngFor="let item of getDirectionChangeItems();let i = index">
        <span style="font-size: 18px;"> {{item.text}}</span>
      </div>
    </div>
    <div class="authority-comment useracceptance-message">
      <div class="comment-wrapper" *ngFor="let item of getCancelItems();let i = index">
        <span style="font-size: 18px;"> {{item.text}}</span>
      </div>
    </div>
    <div class="authority-comment useracceptance-message">
      <div class="comment-wrapper" *ngFor="let item of getReportByItem();let i = index">
        <span style="font-size: 18px;"> {{item.text}}</span>
      </div>
    </div>
  </div>
  <div class="authority-comment {{ comment.type | lowercase }}" *ngFor="let comment of getCommentList()" [hidden]="isAuthorityCard ||  (!authority.isLoggedUserPrimary && [
    eicStatus.RELEASED,
    eicStatus.REJECTED,
    eicStatus.CANCELLED].indexOf(authority.loggedInEICDetail?.status) >= 0)">
    <div *ngIf="comment.type === 'DISPATCHER' || comment.type === 'PRIVATE'">
      <div class="comment-wrapper">
        <span>{{ comment.text }}</span>
      </div>
    </div>
  </div>
  <div class="sharing-status" *ngIf="
      authority.isAuthorityShared &&
      Status.ACTIVE === authority.status &&
      showActionButtons && !isAuthorityCard &&
      (shareInfoPending?.userList.length > 0 || shareInfoReviewRequest?.userList.length > 0 || shareInfoActive?.userList.length > 0)
    ">
    <div class="bottom-align">
      <ul class="horizontal-menu inline pending" *ngIf="!isAuthorityHistory">
        <li *ngIf="shareInfoPending?.userList.length > 0">
        </li>
        <li class="sharing-pipe-desc" *ngFor="let user of shareInfoPending?.userList; let i=index;">
          <span *ngIf="i===0" class="title-container">
            <i class="icon csx-people_user"></i>{{ shareInfoPending?.shareStatus }}:
          </span>
          {{ user.name }}<span class="status">[{{ user.status }}]</span>
        </li>
      </ul>
      <ul class="horizontal-menu inline unshare pending" *ngIf="!isAuthorityHistory">

        <li class="sharing-pipe-desc" *ngFor="let user of shareInfoReviewRequest?.userList; let i=index;"
          (click)="reviewRequest(user.racfId)">
          <span *ngIf="i===0" class="title-container">
            <i class="icon csx-people_user"></i>{{ shareInfoReviewRequest?.shareStatus }}:
          </span>
          {{ user.name
          }}<span class="status" style="cursor: pointer;" [ngClass]="{
              'ui-state-disabled': !systemState.state || isAdmin() || authority.sourceSystemName === Source.TRANSFER_TO_PAPER
            }">[{{ user.status }}]</span>
        </li>
      </ul>
      <ul class="horizontal-menu inline unshare">
        <li class="sharing-pipe-desc" *ngFor="let user of shareInfoActive?.userList; let i=index;">
          <span *ngIf="i===0" class="title-container">
            <i class="icon csx-people_user"></i>{{ shareInfoActive?.shareStatus }}:
          </span>
          {{ user.name
          }}<span *ngIf="!isAuthorityHistory && user.status" style="color:green" class="modification-status" [ngClass]="{
              'ui-state-disabled': !systemState.state || isAdmin(),
              accepted: user.modificationStatus && user.modificationStatus.indexOf('Accepted') >= 0,
              rejected: user.modificationStatus && user.modificationStatus.indexOf('Rejected') >= 0
            }">[<span *ngIf="user.modificationStatus">{{ user.modificationStatus }}</span>
            <span (click)="sendUnshareInitiatedRequest(user)" class="status" style="cursor: pointer;" [ngClass]="{
                'ui-state-disabled':
                  authority.modifyReportbyChangeRequest.authorityChangeRequestStatus ||
                  authority.sourceSystemName === Source.TRANSFER_TO_PAPER
              }">{{ user.status }}</span>]</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="release-share-authority-model" *ngIf="releaseSharedAuthorityModelStatus">
    <app-release-shared-authority [modelOpenStatus]="releaseSharedAuthorityModelStatus"
      (CloseModelStatus)="toggleReleaseAuthorityModel($event)" [eicList]="releaseEicList"
      [reviewSharingRequest]="reviewSharingRequest" [authority]="authority">
    </app-release-shared-authority>
  </div>
</div>

<div *ngIf="!isAuthorityHistory" class="action-confirmation" [ngClass]="{
    'under-action': operatedUpon && isActionAllowed(),
    updated: updated
  }">
  <div class="action-text-message">
    <span *ngIf="authority.status === Status.AUTHORITY_APPROVED">
      This request will be moved to your "cancelled requests"... You may choose to undo this action.
    </span>
    <span *ngIf="authority.status === Status.ACTIVE && !changeRequestPending">
      Are all the people you have given permission to in the clear? Please confirm you are ready to release this
      request.
    </span>
    <span *ngIf="authority.status === Status.RELEASE_APPROVED">
      Are you sure you want to cancel this release?
    </span>
    <span *ngIf="authority.status === Status.ACTIVE && changeRequestPending">
      Are you sure you want to cancel this request?
    </span>
  </div>
  <div class="action-wrapper">
    <div class="action-button-group">
      <button pButton type="button" (click)="updateOperatedUpon(false)" label="Undo"
        class="p-button-outlined"></button>
      <button pButton type="button" (click)="handleConfirmAction()" label="Confirm"></button>
    </div>
  </div>
</div>